;(function () {
  var DURATION = 300

  function initBanner() {
    var dismissed = localStorage.getItem('browserBannerDismissed') === 'true'
    var isChrome = /Chrome\//.test(navigator.userAgent) && !/Edg|OPR/.test(navigator.userAgent)

    if (!dismissed && !isChrome) {
      var banner = document.getElementById('browser-banner')
      if (!banner) return

      banner.style.overflow = 'hidden'
      banner.style.maxHeight = banner.scrollHeight + 'px'
      banner.style.transition = [
        'opacity ' + DURATION + 'ms ease',
        'max-height ' + DURATION + 'ms ease',
        'padding-top ' + DURATION + 'ms ease',
        'padding-bottom ' + DURATION + 'ms ease',
      ].join(', ')
      banner.style.display = ''
    }
  }

  window.dismissBanner = function (persist) {
    if (persist) localStorage.setItem('browserBannerDismissed', 'true')

    var banner = document.getElementById('browser-banner')
    if (!banner) return

    banner.style.opacity = '0'
    banner.style.maxHeight = '0'
    banner.style.paddingTop = '0'
    banner.style.paddingBottom = '0'

    setTimeout(function () {
      banner.style.display = 'none'
    }, DURATION)
  }

  document.addEventListener('DOMContentLoaded', initBanner)
  document.addEventListener('turbo:load', initBanner)
})()
